// extracted by mini-css-extract-plugin
export default {"tabList":"tabList_z6LTipn","gray":"gray_B4LHNcq"};